import { render, staticRenderFns } from "./ManagerChat.vue?vue&type=template&id=ca81fe18&scoped=true&"
import script from "./ManagerChat.vue?vue&type=script&lang=js&"
export * from "./ManagerChat.vue?vue&type=script&lang=js&"
import style0 from "./ManagerChat.vue?vue&type=style&index=0&id=ca81fe18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca81fe18",
  null
  
)

export default component.exports